import CheckCircle from '@mui/icons-material/CheckCircle'
import { Button, ButtonProps, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

export type ClearOrSaveButtonsProps = {
  hasValidDetail?: boolean
  disabled?: boolean
  dirty: boolean
  onClear(): void
  onSubmit(): void
  clearButtonProps?: ButtonProps
  saveButtonProps?: ButtonProps
  testid: string
}

export const ClearOrSaveButtons = ({
  hasValidDetail,
  disabled,
  dirty,
  onClear,
  onSubmit,
  clearButtonProps,
  saveButtonProps,
  testid,
}: ClearOrSaveButtonsProps) => {
  const { t } = useTranslation()

  return (
    <Stack direction="row" spacing={2} padding={2} justifyContent="flex-end">
      <Button
        data-testid={`clear-${testid}-button`}
        variant="outlined"
        onClick={() => onClear()}
        disabled={disabled || !hasValidDetail}
        {...clearButtonProps}
      >
        {clearButtonProps?.children || t('clear')}
      </Button>

      <Button
        variant="contained"
        disabled={disabled || !dirty}
        endIcon={hasValidDetail && !dirty ? <CheckCircle fontSize="small" /> : undefined}
        onClick={onSubmit}
        data-testid={`save-${testid}-button`}
        {...saveButtonProps}
      >
        {saveButtonProps?.children || hasValidDetail
          ? !dirty
            ? t('saved')
            : t('update')
          : t('save')}
      </Button>
    </Stack>
  )
}
